const color = {
  white: "#FFFFFF",
  lightGrey: "#EBEBEB",
  mediumGrey: '#D8D8D8',
  darkGrey: "#979797",
  black: "#090909",
  limeGreen: "#3ECE3C",
}

const palette = {
  base: color.black,
  highlight: color.limeGreen,
  text: color.white,
  lightone: color.lightGrey,
  midtone: color.mediumGrey,
  darktone: color.darkGrey
}

export { palette };



// WEBPACK FOOTER //
// ./src/Styles/colors.js